import $ from 'jquery';
import Glide from '@glidejs/glide';

const pageCarousel = () => {
  const $pageCarouselElem = $('[data-page-carousel]');

  if ($pageCarouselElem.length === 0) {
    return false;
  }

  const carousel = new Glide($pageCarouselElem[0], {
    type: 'carousel',
    startAt: 0,
    perView: 4,
    bound: true,
    breakpoints: {
      1200: {
        perView: 3
      },
      1024: {
        perView: 2
      },
      840: {
        perView: 1
      }
    }
  });

  carousel.mount();
};

export default pageCarousel;
